import { render, staticRenderFns } from "./Mainvisual.vue?vue&type=template&id=6f05309a&scoped=true"
import script from "./Mainvisual.vue?vue&type=script&lang=js"
export * from "./Mainvisual.vue?vue&type=script&lang=js"
import style0 from "./Mainvisual.vue?vue&type=style&index=0&id=6f05309a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05309a",
  null
  
)

export default component.exports